import forms from './forms'

export const formsService = forms
